export default __webpack_public_path__ + "static/media/Logo-text.a918d96e.png";